// Çalışan Raporları (/employee-reports). Proje, merkez ve rol adları kayıtlı
// değerlerdir; Excel dosyası Türkçe kalır.
const employeeReports = {
  page: {
    title: 'Çalışan Raporları',
    subtitle: 'Çalışanların hangi projede, hangi merkezde ve hangi rolle görev aldığı.',
  },
  actions: {
    excel: 'Tabloyu İndir',
    excelHint: 'Listelenen atamaları Excel olarak indir',
  },
  stats: {
    centers: 'Toplam Merkez Sayısı',
    centersShort: 'Merkez',
    projects: 'Toplam Proje Sayısı',
    projectsShort: 'Proje',
    workers: 'Toplam Çalışan Sayısı',
    workersFiltered: 'Filtrelenmiş Çalışan Sayısı',
    workersShort: 'Çalışan',
    assignments: '{{count}} atama',
  },
  toolbar: {
    search: 'İsim ile ara…',
    searchShort: 'Çalışan ara…',
    project: 'Proje',
    allProjects: 'Tüm projeler',
    center: 'Merkez',
    allCenters: 'Tüm merkezler',
  },
  columns: {
    name: 'Çalışan',
    center: 'Merkez',
    project: 'Proje',
    role: 'Rol',
    rate: 'Tarife',
    assignedAt: 'Atanma Tarihi',
  },
  table: {
    listLabel: 'Çalışan atamaları',
    empty: 'Seçilen kriterlere uygun çalışan bulunmamaktadır.',
    rangeOf: '/ {{total}} atama',
    ofTotal: 'toplam {{total}} atama içinden',
    jump: 'Sayfaya git',
  },
  panel: {
    label: 'Seçili atama',
    heading: 'Proje ataması',
    visits: 'Visitleri Göster',
    otherAssignments: 'Diğer atamaları',
  },
  toast: {
    centersError: 'Merkez listesi yüklenirken hata oluştu!',
    projectsError: 'Proje listesi yüklenirken hata oluştu!',
    noVisits: 'Bu çalışanın visit’i bulunamadı.',
    visitsError: 'Visit bilgileri yüklenirken bir hata oluştu.',
    excelDone: 'Excel dosyası başarıyla indirildi',
    pageJumpInvalid: 'Lütfen 1 ile {{max}} arasında bir sayfa numarası girin.',
  },
};

export default employeeReports;
